<template>
  <div />
</template>

<script>
    export default {
        name: "RentalSignupStep2"
    }
</script>

<style scoped>

</style>